import { render, staticRenderFns } from "./AlphabetTableLv2.vue?vue&type=template&id=19c5fc6c&scoped=true"
import script from "./AlphabetTableLv2.vue?vue&type=script&lang=js"
export * from "./AlphabetTableLv2.vue?vue&type=script&lang=js"
import style0 from "./AlphabetTableLv2.vue?vue&type=style&index=0&id=19c5fc6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5fc6c",
  null
  
)

export default component.exports